<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{ name: 'home' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">{{ VUE_ENV.VUE_APP_NAME }} Points</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div
                class="section detail-transaction-section"
                style="--height: 60px; padding-top: 5px"
            >
                <div class="detail-card">
                    <div class="row">
                        <div class="col-3">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="require('@/assets/points.svg')"
                                alt="image"
                                class="w-100"
                            />
                        </div>
                        <div class="col-9">
                            <div class="row">
                                <div class="col-6 text-left">
                                    <span
                                        style="font-size: 13px; color: #17273e"
                                        >Total Points</span
                                    >
                                    <h1
                                        class="text-primary"
                                        :class="{
                                            'loading-component':
                                                loading.content,
                                        }"
                                        style="font-size: 17px"
                                    >
                                        <span>{{ totalPoints | rupiah }}</span>
                                    </h1>
                                </div>
                                <div class="col-6 text-right">
                                    <span
                                        style="font-size: 13px; color: #17273e"
                                        >Pending Points</span
                                    >
                                    <h1
                                        class="text-primary"
                                        :class="{
                                            'loading-component':
                                                loading.content,
                                        }"
                                        style="font-size: 17px"
                                    >
                                        <span>{{
                                            pointsPending | rupiah
                                        }}</span>
                                    </h1>
                                </div>
                            </div>
                            <div class="row">
                                <div
                                    style="
                                        padding-left: 8px;
                                        padding-right: 8px;
                                    "
                                >
                                    <router-link
                                        :to="{ name: 'points.history' }"
                                        class="btn btn-sm btn-primary pl-2 pr-2"
                                        style="border-radius: 100px"
                                    >
                                        Riwayat Points
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section full mt-3 mb-2">
                <div class="section-heading padding">
                    <h2 class="title">Pilihan Tukar Points</h2>
                </div>
                <div v-if="rewards.length > 0">
                    <carousel
                        :autoplay="false"
                        :nav="false"
                        :dots="false"
                        :loop="false"
                        :items="2"
                        :stagePadding="15"
                        :margin="7"
                    >
                        <div
                            class="item"
                            v-for="(item, index) in rewards"
                            :key="index"
                        >
                            <a
                                :class="
                                    item.status == 0 ? 'disabled-product' : ''
                                "
                            >
                                <div class="blog-card">
                                    <img
                                        :src="
                                            VUE_ENV.VUE_APP_ASSET_URL +
                                            '/img/rewards/' +
                                            item.image
                                        "
                                        alt="image"
                                        class="imaged w-100"
                                    />
                                    <div class="text pt-1 pb-1 pl-1 pr-1">
                                        <h4
                                            class="title"
                                            style="
                                                height: 40px;
                                                font-size: 13px;
                                                font-weight: bold;
                                                line-height: 18px;
                                            "
                                        >
                                            {{ item.reward_name }}
                                        </h4>
                                        <div style="line-height: 18px">
                                            <div
                                                class="text-warning"
                                                style="font-size: 11px"
                                            >
                                                {{
                                                    item.points_required
                                                        | rupiah
                                                }}
                                                points
                                            </div>
                                            <footer
                                                class="text-secondary"
                                                style="font-size: 12px"
                                            >
                                                Tersisa {{ item.stock }}
                                            </footer>
                                            <div class="text-right">
                                                <button
                                                    class="btn btn-primary btn-sm mt-1"
                                                    style="
                                                        padding: 0px 25px;
                                                        border-radius: 100px;
                                                    "
                                                    :disabled="
                                                        totalPoints <
                                                        item.points_required
                                                    "
                                                    @click="
                                                        showModalRedeem(item)
                                                    "
                                                >
                                                    Tukar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </carousel>
                </div>
            </div>

            <div class="section mt-3 mb-3">
                <div class="section-heading">
                    <h2 class="title">
                        Tentang {{ VUE_ENV.VUE_APP_NAME }} Points
                    </h2>
                </div>
                <div class="padding">
                    <p
                        style="
                            line-height: 17px;
                            font-size: 12px;
                            text-align: justify;
                        "
                    >
                        {{ VUE_ENV.VUE_APP_NAME }} points merupakan cara kami
                        menghargai pengguna yang telah setia menggunakan layanan
                        kami. {{ VUE_ENV.VUE_APP_NAME }} points dibuat dalam
                        bentuk program reward yang memungkinkan pengguna
                        {{ VUE_ENV.VUE_APP_NAME }} untuk mendapatkan points yang
                        dapat ditukarkan dengan berbagai hadiah menarik.
                    </p>
                    <h5>Cara mendapatkan points</h5>
                    <div class="row">
                        <div class="col-2">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    require('@/assets/points_transaction.svg')
                                "
                                alt="image"
                                class="w-100"
                            />
                        </div>
                        <div class="col-10">
                            <p
                                style="
                                    line-height: 17px;
                                    font-size: 12px;
                                    text-align: justify;
                                "
                            >
                                {{ VUE_ENV.VUE_APP_NAME }} points dapat
                                diperoleh dari transkasi seperti transaksi isi
                                ulang, bayar tagihan dan kirim uang.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    require('@/assets/points_verification.svg')
                                "
                                alt="image"
                                class="w-100"
                            />
                        </div>
                        <div class="col-10">
                            <p
                                style="
                                    line-height: 17px;
                                    font-size: 12px;
                                    text-align: justify;
                                "
                            >
                                {{ VUE_ENV.VUE_APP_NAME }} points juga dapat
                                didapatkan dari melengkapi profil akun dan
                                melakukan verifikasi data diri.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    require('@/assets/points_mission.svg')
                                "
                                alt="image"
                                class="w-100"
                            />
                        </div>
                        <div class="col-10">
                            <p
                                style="
                                    line-height: 17px;
                                    font-size: 12px;
                                    text-align: justify;
                                "
                            >
                                Dengan mengikuti dan menyelesaikan berbagai misi
                                menarik di {{ VUE_ENV.VUE_APP_NAME }} juga akan
                                mendapatkan {{ VUE_ENV.VUE_APP_NAME }}
                                Points.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="require('@/assets/points_event.svg')"
                                alt="image"
                                class="w-100"
                            />
                        </div>
                        <div class="col-10">
                            <p
                                style="
                                    line-height: 17px;
                                    font-size: 12px;
                                    text-align: justify;
                                "
                            >
                                Kamu juga bisa mendapatkan
                                {{ VUE_ENV.VUE_APP_NAME }} points dari mengikuti
                                event dan kegiatan lainnya yang diselenggarakan
                                oleh pihak {{ VUE_ENV.VUE_APP_NAME }}.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal konfirmasi pembelian -->
        <action-sheet
            ref="modal_confrimation_redeem"
            :title="'Konfirmasi Penukaran Points'"
            :header="true"
            :inset="false"
            :content-height="true"
        >
            <div class="mb-1 pb-1" style="border-bottom: 1px dashed #dee2e6">
                <p style="font-size: 13px; line-height: 18px">
                    Dengan menukar, kamu akan memiliki
                    <b>{{ rewards_selected.reward_name }}</b> cuma dengan
                    memakai
                    <b>{{ rewards_selected.points_required | rupiah }}</b>
                    Points!
                </p>
            </div>

            <div class="form-group basic pb-0">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-outline-primary btn-block btn-lg"
                            style="height: 40px; border-width: 1px"
                            @click="hideModalRedeem()"
                        >
                            Batal
                        </button>
                    </div>
                    <div class="col-6">
                        <button
                            class="btn btn-primary btn-block btn-lg"
                            style="height: 40px; border-width: 1px"
                            @click="verifyWithPin()"
                            :disabled="
                                totalPoints < rewards_selected.points_required
                            "
                        >
                            Tukarkan
                        </button>
                    </div>
                </div>
            </div>
        </action-sheet>

        <!-- Modal Status Pembelian  -->
        <action-sheet ref="status" :title="'Status Penukaran'" :inset="true">
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Penukaran Points Berhasil</h3>
                <p>Penukaran Anda sedang diproses</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="directToHistory()"
                >
                    Lihat Riwayat Penukaran
                </button>
                <button
                    class="btn btn-outline-primary btn-block btn-lg"
                    @click="hideStatus()"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import $axios from './../../api.js';
    import { mapState } from 'vuex';
    import carousel from 'vue-owl-carousel';
    export default {
        components: { carousel },
        props: ['toast_reference'],
        data() {
            return {
                affiliate_id: '',
                loadingApp: true,
                loading: {
                    content: false,
                },
                loadingButton: false,
                totalPoints: 0,
                pointsPending: 0,
                rewards: [],
                rewards_selected: {
                    points_required: '0',
                },
                redeem_data: {
                    reward_id: '',
                },
            };
        },
        created() {
            this.loadingApp = false;
            this.getTotalPoints();
            this.getRewards();
        },
        computed: {
            ...mapState(['customer', 'toast', 'VUE_ENV']),
        },
        methods: {
            getTotalPoints() {
                this.loading.content = true;
                $axios
                    .get('/points/total')
                    .then(response => {
                        this.totalPoints = response.data.data.points;
                        this.pointsPending = response.data.data.pointsPending;
                        this.loading.content = false;
                    })
                    .catch(() => {
                        this.loading.content = false;
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: 'Gagal menampilkan data',
                            tipe: 'default',
                            icon: 'danger',
                        });
                    });
            },
            getRewards() {
                this.loading.content = true;
                $axios
                    .get('/points/rewards')
                    .then(response => {
                        this.rewards = response.data.data;
                        this.loading.content = false;
                    })
                    .catch(() => {
                        this.loading.content = false;
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: 'Gagal menampilkan data',
                            tipe: 'default',
                            icon: 'danger',
                        });
                    });
            },
            showModalRedeem(item) {
                this.rewards_selected = item;
                this.redeem_data.reward_id = item.id;
                let element = this.$refs.modal_confrimation_redeem.$el;
                window.$(element).modal('show');
            },
            hideModalRedeem() {
                let element = this.$refs.modal_confrimation_redeem.$el;
                window.$(element).modal('hide');
            },
            verifyWithPin() {
                this.hideModalRedeem();
                this.$router.push({
                    name: 'auth.pin.verify',
                    params: {
                        data_reference: this.redeem_data,
                        url_reference: '/points/redeem',
                        previous_page_reference: 'points',
                        next_page_reference: 'points',
                    },
                });
            },
            showStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('show');
            },
            hideStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('hide');
            },
            directToHistory() {
                this.hideStatus();
                this.$router.push({
                    name: 'transaction.history',
                });
            },
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.showStatus();
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 300);
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
